module.exports = __webpack_public_path__ + "svg/illustration-kids.520e280.svg";